import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const Agent = ({ agent, campaign }) => (
  <div className={styles.root}>
    <div className={styles.details}>
      <span className={styles.name}>{agent.full_name}</span>
      <a className={styles.phone} href={`tel:${agent.mobile ? agent.mobile.replace(/\s/g, '') : ''}`}>{agent.mobile}</a>
      <a
        className={styles.email}
        href={`mailto:${agent.email}?subject=Proposal for ${campaign.address}, ${campaign.suburb_name}`}
      >
        {agent.email}
      </a>
    </div>
  </div>
)

Agent.propTypes = {
  agent: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default Agent
